import { UTToast } from '@group-link-one/gl-ui/utilities';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import type { IPageLayoutRight } from '../types/PageLayoutRight.types';
import { TopContentContainer } from './PageLayoutStyle';
import { usePageLayoutContent } from './usePageLayoutContent';
import { useProfile } from '@/Auth/contexts/ProfileContext';
import { getPageTitle } from '@/config/pageTitles';
import { useCurrentUserRole } from '@/Hooks/useCurrentUserRole';
import { PageHeader } from '@/Shared/components/PageHeader/PageHeader';

export function PageLayoutContent({ children, id }: IPageLayoutRight) {
  const { content, snackbar, setSnackbarState, headerActions } = usePageLayoutContent();
  const { pathname } = useLocation();
  const { profile } = useProfile();
  const role = useCurrentUserRole();

  const { eyebrow, title } = getPageTitle(pathname);

  return (
    <>
      <AnimatePresence mode='wait' initial={false}>
        {!!content && (
          <TopContentContainer
            key={`${id}-top-content`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            {content}
          </TopContentContainer>
        )}

        {!content && (
          <motion.div
            key={`${id}-topbar`}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <PageHeader
              eyebrow={eyebrow}
              title={title}
              actions={headerActions}
              user={profile ? { name: profile.name, role } : undefined}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence mode='wait' initial={false}>
        {!!snackbar && (
          <motion.div
            key={`${id}-snackbar`}
            initial={{ opacity: 0, y: -20, height: 0 }}
            animate={{ opacity: 1, y: 0, height: 'auto' }}
            exit={{ opacity: 0, y: -20, height: 0 }}
          >
            <UTToast
              {...snackbar}
              mode='snackbar'
              title={snackbar.title || ''}
              message={snackbar.message || ''}
              onClose={() => setSnackbarState(null)}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {children}
    </>
  );
}
